import React, { useEffect, useState } from "react";
import {
	Grid,
	Typography,
	Button,
	TextField,
	MenuItem,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	TablePagination,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle
} from "@mui/material";
import Layout from "../../components/Wrappers/Layout";
import { Card, Alert } from "reactstrap";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@mui/styles";
import { getWithdrawalcount } from "../../redux/actions/getWithdrawalCountAction";
import { updateWithdrawalCount } from "../../redux/actions/updateWithdrawalCountAction";
import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
import { useDeferredValue } from "react";
import SaveIcon from "@mui/icons-material/Save";
import BackButton from "../../components/BackButton/BackButton";
import Util from "../../validation";
import CustomButton from "../../components/CustomButton/CustomButton";
import SOLogout from "../../components/Logout/SOLogout";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";

const useStyles = makeStyles({
	table: {
		minWidth: 650
	}
});

function WLAddWithdrawalCount() {
	const [withdrawAllowed, setWithdrawAllowed] = useState("");
	const [withDrawCountStatus, setWithDrawCountStatus] = useState(false);
	const [updatewithDrawCountArray, setUpdatewithDrawCountArray] = useState([]);
	const classes = useStyles();
	const dispatch = useDispatch();

	// const partnerloginUser = useSelector(({ login }) => login);
	// var authToken = partnerloginUser.data.AuthToken;

	const regenerateTokenRes = useSelector(
		({ regenerateToken }) => regenerateToken
	);
	// console.log("regenerateTokenRes", regenerateTokenRes);
	var authToken = regenerateTokenRes.data.AuthToken;

	const [notificationOpen, setNotificationOpen] = React.useState(false);
	const handleChange = ({ target: { name, value } }) => {
		if (name === "WithdrawAllowed") {
			Util.verifyAmount(value)
				? setWithdrawAllowed(value)
				: setWithdrawAllowed(withdrawAllowed);
			//setWithdrawAllowed(value);
		}
	};

	const getWithdrawalcountRes = useSelector(
		({ getWithdrawalCount }) => getWithdrawalCount
	);

	const updateWithdrawalCountRes = useSelector(
		({ updateWithdrawalCount }) => updateWithdrawalCount
	);

	// console.log("updateWithdrawalCountRes", updateWithdrawalCountRes);

	const handleNoticationClose = () => {
		setNotificationOpen(false);
	};

	const updateWithdrawalCountFunc = () => {
		setWithDrawCountStatus(true);
		const updateWithdrawalCountReq = {
			loginDetails: {
				walletOwnerId: regenerateTokenRes.data.partnerId || ""
			},
			withDrawalCount: withdrawAllowed
		};
		return dispatch(updateWithdrawalCount(updateWithdrawalCountReq, authToken));
	};

	const getWithdrawalcountFunc = () => {
		dispatch(
			getWithdrawalcount(
				{
					loginDetails: {
						walletOwnerId: regenerateTokenRes.data.partnerId || ""
					}
				},
				regenerateTokenRes.data.AuthToken
			)
		);
	};

	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			getWithdrawalcountFunc();
		}
	}, [regenerateTokenRes.data.status]);

	useEffect(() => {
		if (withDrawCountStatus) {
			updateWithdrawalCountResFun();
		}
	}, [updateWithdrawalCountRes.data.status]);

	useEffect(() => {
		setWithdrawAllowed(getWithdrawalcountRes.data.withDrawalCount);
	}, [getWithdrawalcountRes.data]);

	const updateWithdrawalCountResFun = () => {
		if (withDrawCountStatus) {
			if (updateWithdrawalCountRes.data.status == "success") {
				setUpdatewithDrawCountArray(updateWithdrawalCountRes.data);
				setNotificationOpen(true);
			}
			if (updateWithdrawalCountRes.data.status == "failed") {
				setUpdatewithDrawCountArray(updateWithdrawalCountRes.data);
				setNotificationOpen(true);
				if (
					updateWithdrawalCountRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					updateWithdrawalCountRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (updateWithdrawalCountRes.data.status == "Failed") {
				setUpdatewithDrawCountArray(updateWithdrawalCountRes.data);
				setNotificationOpen(true);
				if (
					updateWithdrawalCountRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					updateWithdrawalCountRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	return (
		<>
			<Layout>
				<BackButton />
				<Card>
					{/* <BackButton /> */}
					<Grid
						container
						spacing={1}
						style={{
							padding: "8px",
							marginTop: "1rem",
							marginBottom: "1rem",
							justifyContent: "center"
						}}
					>
						<Grid
							className="mx-4"
							item
							sm={12}
							md={5}
							lg={5}
							style={{ width: "100%" }}
						>
							<TextField
								required
								size="small"
								color="primary"
								variant="standard"
								autoFocus={true}
								type="text"
								label="Number of Withdraw Allowed"
								fullWidth={true}
								name="WithdrawAllowed"
								value={withdrawAllowed || ""}
								onChange={handleChange}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							/>
						</Grid>
						<Grid item sm={12} md={2} lg={2}>
							{/* <Button
                style={{
                  backgroundColor: "#00b9f5",
                  color: "white",
                  marginTop: "7px",
                }}
                variant="contained"
                className="riskRuleButton"
                onClick={updateWithdrawalCountFunc}
                endIcon={<SaveIcon />}
              >
                Save
              </Button> */}
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={updateWithdrawalCountFunc}
								endIcon={<SaveIcon />}
							>
								Save <SaveIcon />
							</CustomButton>
						</Grid>
					</Grid>
				</Card>
			</Layout>

			{updatewithDrawCountArray.status == "success" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={success} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{updatewithDrawCountArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							{/* <Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button> */}
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={handleNoticationClose}
								// endIcon={<SaveIcon />}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{updatewithDrawCountArray.status == "Failed" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{updatewithDrawCountArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							{/* <Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button> */}
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={handleNoticationClose}
								// endIcon={<SaveIcon />}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}
		</>
	);
}

export default WLAddWithdrawalCount;
